import { IPlugin, PluginStore } from "react-pluggable";
import RegisterNowComponent from "./components/RegisterNow/RegisterNow";


class RegisterNowPlugin implements IPlugin {
    pluginStore!: PluginStore;

    getPluginName(): string {
        return "RegisterNow@1.0.0"
    }
    getDependencies(): string[] {
        return [];
    }
    init(pluginStore: PluginStore): void {
        this.pluginStore = pluginStore;
    }
    activate(): void {
        this.pluginStore.executeFunction("Renderer.add", "loginOptions:inside", () => (
            <RegisterNowComponent></RegisterNowComponent>
        ));
    }
    deactivate(): void {
    }

}

export default RegisterNowPlugin;